<template>
  <vx-card title="Top motivos de demora">
    <p class="gw-bajada">
      Motivos de espera registrados en tus procesos, ordenados por el tiempo
      acumulado que representan. La etiqueta de cada barra indica en cuántas
      validaciones se registró el motivo. El tiempo de gestión sin un motivo
      registrado no aparece aquí: se atribuye a Globalwork y se ve en "De
      quién fue el tiempo".
    </p>

    <apexcharts
      v-if="hayDatos"
      type="bar"
      :height="alto"
      :options="opciones"
      :series="series"
    />
    <p v-else class="gw-sin-datos">No hay motivos de espera registrados en este periodo.</p>

    <p v-if="hayDatos" class="gw-leyenda">
      <span class="gw-punto gw-punto-excluible"></span> Espera excluida del cómputo
      <span class="gw-punto gw-punto-imputable"></span> Espera incluida en el cómputo
    </p>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import slaFormat from "../../mixins/slaFormat";

const MAXIMO = 8;

export default {
  name: "SlaTopReasons",
  mixins: [slaFormat],
  components: { apexcharts: VueApexCharts },
  props: {
    motivos: { type: Array, default: () => [] },
  },

  computed: {
    filas() {
      return this.motivos.slice(0, MAXIMO);
    },

    hayDatos() {
      return this.filas.length > 0;
    },

    alto() {
      return Math.max(220, 46 * this.filas.length + 60);
    },

    unidad() {
      return this.unidadPara(this.filas.map((f) => f.minutos));
    },

    series() {
      return [
        {
          name: "Tiempo acumulado",
          data: this.filas.map((f) => this.enUnidad(f.minutos, this.unidad)),
        },
      ];
    },

    opciones() {
      const filas = this.filas;
      const unidad = this.unidad;
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, distributed: true, barHeight: "62%" } },
        // El color aquí sí lleva información: distingue el tiempo que el
        // contrato no nos imputa del que sí.
        colors: filas.map((f) => (f.excluible ? "#9A5FC0" : "#5F0091")),
        legend: { show: false },
        dataLabels: {
          enabled: true,
          formatter: (v, ctx) =>
            filas[ctx.dataPointIndex].veces +
            (filas[ctx.dataPointIndex].veces === 1 ? " vez" : " veces"),
          style: { fontSize: "11px", colors: ["#fff"] },
        },
        grid: { borderColor: "#eee" },
        xaxis: {
          categories: filas.map((f) => this.recortar(f.etiqueta)),
          title: {
            text: unidad.sufijo,
            style: { color: this.GW_GRIS_SUAVE, fontSize: "11px", fontWeight: 400 },
          },
          labels: { style: { colors: this.GW_GRIS_SUAVE, fontSize: "11px" } },
        },
        yaxis: {
          labels: {
            style: { colors: this.GW_GRIS, fontSize: "12px" },
            maxWidth: 330,
          },
        },
        tooltip: {
          y: {
            formatter: (v, ctx) => {
              const f = filas[ctx.dataPointIndex];
              return v + " " + unidad.sufijo +
                (f.excluible ? " · no cuenta contra el ANS" : " · cuenta contra el ANS");
            },
          },
          x: { formatter: (_, ctx) => filas[ctx.dataPointIndex].etiqueta },
        },
      };
    },
  },

  methods: {
    recortar(texto) {
      const t = String(texto || "");
      return t.length > 58 ? t.slice(0, 55) + "…" : t;
    },
  },
};
</script>

<style scoped>
.gw-bajada {
  font-size: 12px;
  color: #9a9a9a;
  margin: -6px 0 14px;
  max-width: 62ch;
}
.gw-sin-datos {
  font-size: 12px;
  color: #9a9a9a;
}
.gw-leyenda {
  font-size: 11px;
  color: #9a9a9a;
  margin: 8px 0 0;
}
.gw-punto {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin: 0 5px 0 14px;
}
.gw-leyenda .gw-punto:first-child {
  margin-left: 0;
}
.gw-punto-excluible {
  background: #9a5fc0;
}
.gw-punto-imputable {
  background: #5f0091;
}
</style>
